<div style="margin-bottom: 5px; margin-top: 20px;">
  <ion-card class="card"
    [ngStyle]="{'background-image': 'linear-gradient(#826149aa 10%, transparent 20%), url(' + getImage() + ')', height:imageHeight}">
    <ion-row>
      <ion-col size="9">
        <div class="font1_5 scrollable" style="height: 8vw;" (click)="viewFeedDetails()">{{feed.header}}</div>
        <div class="scrollable" *ngIf="!details" style="height: 16vw;">{{feed.description}}</div>
      </ion-col>
      <ion-col size="2">

      </ion-col>
      <ion-col size="1" style="height: 24vw;" class="scrollable">
        <div *ngIf="feed.reactionKeys">
          <div class="singleLine" *ngFor="let key of feed.reactionKeys">{{feed.reaction_count[key]}} {{key}}</div>
        </div>
      </ion-col>
    </ion-row>

    <ion-row *ngIf="showEmojiBox" class="emojiBox">
      <ion-col size="2" *ngFor="let emoji of reactionService.emojiList" (click)="clickEmoji(emoji)" class="font1_5">
        {{emoji}}
      </ion-col>
    </ion-row>
  </ion-card>
  <ion-card style="margin: -15px 5px 5px 5px;">

    <ion-row class="creatorBox">

      <ion-col size="1">
        <ion-icon color="tertiary" (click)="feedService.share(feed)" name="share-social-outline"></ion-icon>
      </ion-col>
      <ion-col size="10">
        <div style="width: 100%; overflow-x: auto; white-space: nowrap;"
          *ngIf="feed.json_details && feed.json_details.facilities">
          <ion-badge color="secondary" *ngFor="let item of feed.json_details.facilities.split(',')" mode="ios"
            class="margin2px" style="display: inline-block;">
            {{ item }}
          </ion-badge>
        </div>
        <!-- {{feed.json_details.facilities}} -->
      </ion-col>
      <ion-col size="1">
        <ion-icon (click)="viewFeedDetails()" name="chatbubble-outline"></ion-icon>
      </ion-col>

      <ion-col size="1">
        <ion-icon color="tertiary" name="call-outline"></ion-icon>
      </ion-col>
      <ion-col size="10">
        <div style="width: 100%; overflow-x: auto; white-space: nowrap;">
          <b>{{feed.json_details.contact}}</b>, <a style="color:white"
            [href]="'tel:'+feed.json_details.contact_number">{{feed.json_details.contact_number}}</a>
        </div>
      </ion-col>
      <ion-col size="1">
        <ion-icon (click)="showEmojiBox = !showEmojiBox" name="heart-outline"></ion-icon>
      </ion-col>

      <ion-col size="1">
        <ion-icon color="danger" name="location-outline"></ion-icon>
      </ion-col>
      <ion-col size="8.5">
        {{feed.json_details.address}}
      </ion-col>
      <ion-col size="2.5">
        <ion-badge (click)="openMap(feed.json_details.map)" color="danger" mode="ios">View Map</ion-badge>
      </ion-col>
    </ion-row>
    <div *ngIf="details" style="height: 16vw;">{{feed.description | linebreaks}}</div>
    <ion-row *ngIf="details">      
      <ion-col size="1.5">
        <span *ngIf="feed.creator">
          <img width="30px" height="30px" [src]="feed.creator.url" *ngIf="feed.creator && feed.creator.url"
            class="circular">
          <ion-icon name="person-circle-outline" *ngIf="!feed.creator.url" class="font3" color="light"></ion-icon>
        </span>
      </ion-col>
      <ion-col [size]="details ? '9.5' : '7.5'">
        <div *ngIf="feed.creator">{{feed.creator.name}}</div>
        <div class="font0_8">{{feed.created_at | fancyDate}}</div>

      </ion-col>
      <ion-col size="1">
        <ion-icon name="logo-whatsapp" (click)="feedService.share(feed)"></ion-icon>
      </ion-col>
      <ion-col size="1" *ngIf="!details">
        <ion-icon (click)="showEmojiBox = !showEmojiBox" name="heart-outline"></ion-icon>
      </ion-col>
      <ion-col size="1" *ngIf="!details">
        <ion-icon (click)="viewFeedDetails()" name="chatbubble-outline"></ion-icon>
      </ion-col>
    </ion-row>
  </ion-card>

</div>